import EventsPage from './pages/EventsPage';
import HomePage from './pages/HomePage';

export const homeRoute = {
  name: 'home',
  path: '/',
  exact: true,
  component: HomePage,
};

export const eventsRoute = {
  name: 'events',
  path: '/events',
  exact: true,
  component: EventsPage,
};

export const routes = [homeRoute, eventsRoute];